import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class BrowserSnifferService {

  /**
   * by default only portrait on phone size
   * if a project doesn't need/want this behaviour, it should update this setting on startup via setter isLockedOrientationOnPhone
   * this property only has effect on native android apps (for ios it's done via config)
   */
  private _lockedOrientationOnPhone: boolean = true;

  isMobile = signal(false);
  isPhone = signal(false);
  isTablet = signal(false);
  isDesktop = signal(false);
  isLargeDesktop = signal(false);

  constructor(private breakpointObserver: BreakpointObserver) {

    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge
      ])
      .subscribe(state => {
        this.isPhone.set(state.breakpoints[Breakpoints.XSmall] === true);
        this.isMobile.set(
          state.breakpoints[Breakpoints.XSmall] ||
          state.breakpoints[Breakpoints.Small]
        );
        this.isTablet.set(
          state.breakpoints[Breakpoints.Small] ||
          state.breakpoints[Breakpoints.Medium]
        );
        this.isDesktop.set(
          state.breakpoints[Breakpoints.Medium] ||
          state.breakpoints[Breakpoints.Large] ||
          state.breakpoints[Breakpoints.XLarge]
        );
        this.isLargeDesktop.set(state.breakpoints[Breakpoints.XLarge] === true);

        //this will only have effect on native apps
        if (this._lockedOrientationOnPhone) {
          this.toggleLockedOrientation();
        }
      });
  }

  // subscribeToLayoutChanges(): Observable<BreakpointState> {
  //     return this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]);
  // }
  // subscribeToPhoneChanges(): Observable<BreakpointState> {
  //     return this.breakpointObserver.observe([Breakpoints.XSmall]);
  // }

  get isTouchDevice(): boolean {
    return 'ontouchstart' in window;
  }

  get isMobileOS(): boolean {
    try {
      // 'android', 'ios', 'web'
      if (/^(android|ios)$/.test(Capacitor.getPlatform())) return true;
      return /Mobi|android|webos|iphone|ipad|opera mini/i.test(navigator.userAgent);
    } catch (error) { }
    return false;
  }

  set isLockedOrientationOnPhone(lockOrientationOnPhone: boolean) {
    if (this._lockedOrientationOnPhone !== lockOrientationOnPhone) {
      this._lockedOrientationOnPhone = !this._lockedOrientationOnPhone;
      this.toggleLockedOrientation();
    }
  }
  get isLockedOrientationOnPhone() {
    return this._lockedOrientationOnPhone
  }

  private async toggleLockedOrientation() {
    if (Capacitor.getPlatform() === 'android') {
      if (this._lockedOrientationOnPhone) {
        if (this.isPhone()) {
          //lock to portrait for phone
          await ScreenOrientation.lock({ orientation: 'portrait' });
        } else {
          //unlock for tablets + desktops
          await ScreenOrientation.unlock();
        }
      } else {
        //unlock for all sizes
        await ScreenOrientation.unlock();
      }
    }
  }

  public getOS(): 'ios' | 'android' | 'windows' | 'macos' | '' {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    if (/Win/.test(ua)) return 'windows';
    if (/Mac/.test(ua) && !/iPhone|iPad|iPod/.test(ua)) return 'macos';
    return '';
  }
}


/*
// import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';

// @Injectable({
//     providedIn: 'root'
// })

// export class BrowserSnifferService {

//     constructor(private breakpointObserver: BreakpointObserver) {
//     }

//     subscribeToLayoutChanges(): Observable<BreakpointState> {
//         return this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]);
//     }
//     subscribeToPhoneChanges(): Observable<BreakpointState> {
//         return this.breakpointObserver.observe([Breakpoints.XSmall]);
//     }

//     get isPhone() {
//         return this.breakpointObserver.isMatched([Breakpoints.XSmall]);
//     }
//     get isMobile() {
//         return this.breakpointObserver.isMatched([Breakpoints.Small, Breakpoints.XSmall]);
//     }
//     get isTablet() {
//         return this.breakpointObserver.isMatched([Breakpoints.Small,Breakpoints.Medium]);
//     }
//     get isDesktop() {
//         return this.breakpointObserver.isMatched([Breakpoints.Large, Breakpoints.XLarge]);
//     }
//     get isLargeDesktop() {
//         return this.breakpointObserver.isMatched([Breakpoints.XLarge]);
//     }
    
//     get isTouchDevice(): boolean {
//         //pve had false with 2nd arg: have to ask...
//         if ("ontouchstart" in window)//|| window.TouchEvent
//             return true;

//         const prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
//         const queries = prefixes.map(prefix => `(${prefix}touch-enabled)`);

//         return window.matchMedia(queries.join(",")).matches;
//     }

//     get isMobileOS(): boolean {
//         try {
//             if (/Mobi/.test(navigator.userAgent)) {
//                 return true;
//             }
//             //only strings for which we are sure it's mobile only, e.g. 'chrome' can be desktop
//             if (
//                 /android|webos|iphone|ipad|opera mini/i.test(
//                     navigator.userAgent.toLowerCase()
//                 )
//             ) {
//                 return true;
//             }
//         } catch (error) { }
//         return false;
//     }
// }
*/